export const SUBMIT_FORM = "SUBMIT_FORM";
export const ITEM_LIST_LOADING = "ITEM_LIST_LOADING";
export const LOAD_ITEM_LIST = "LOAD_ITEM_LIST";
export const ITEM_LIST_FAILED = "ITEM_LIST_FAILED";

export const ADD_TO_CART="ADD_TO_CART";
export const DELETE_CART = "DELETE_CART";
export const DELETE_ALL_CART = "DELETE_ALL_CART";